<template>
  <div>
    <table class="table">
      <thead>
        <th>Scan</th>
        <th>Analyse</th>
        <th>Lean</th>
        <th>Value</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <textarea name="scanText" id="" cols="30" rows="10"></textarea>
          </td>

          <td>
            <textarea name="analyseText" id="" cols="30" rows="10"></textarea>
          </td>

          <td>
            <textarea name="leanText" id="" cols="30" rows="10"></textarea>
          </td>

          <td>
            <textarea name="valueText" id="" cols="30" rows="10"></textarea>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Salve"
};
</script>
